import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ALink from '../../common/ALink';
import useTranslation from '../../../utils/hooks/useTranslation';
import { removeXSSAttacks } from '../../../utils';

function BlogSingle({ blog, loading }) {
    const { t } = useTranslation();

    if (loading) {
        return <div className="skel-post" />;
    }

    const date = new Date(blog?.created_at);
    const monthArray = [
        t('label.jan'), t('label.feb'), t('label.mar'),
        t('label.apr'), t('label.may'), t('label.jun'),
        t('label.jul'), t('label.aug'), t('label.sep'),
        t('label.oct'), t('label.nov'), t('label.dec')
    ];
    const day = date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : date.getUTCDate();
    const formattedDate = `${monthArray[date.getUTCMonth()]} ${day}, ${date.getUTCFullYear()}`;

    return (
        <article className="blog-single-modern">
            <ALink href="/blog" className="blog-single-back">
                <i className="icon-angle-left" />
                {t('message.back_to_blog')}
            </ALink>

            <div className="blog-single-meta">
                <span>{t('message.article')}</span>
                <span className="blog-single-meta-dot" />
                <time className="blog-single-meta-muted" dateTime={date.toISOString()}>
                    {formattedDate}
                </time>
            </div>

            <h1 className="blog-single-title">{blog.title}</h1>

            {blog?.image?.url && (
                <figure className="blog-single-hero">
                    <LazyLoadImage
                        alt={blog.title}
                        src={process.env.REACT_APP_PUBLIC_ASSET_URI + blog.image.url}
                        threshold={500}
                        width="100%"
                        height="100%"
                        effect="opacity"
                    />
                </figure>
            )}

            <div
                className="blog-single-content long-description-format"
                dangerouslySetInnerHTML={removeXSSAttacks(blog.description)}
            />
        </article>
    );
}

export default BlogSingle;
